import { ComplianceStatusType, ResultStatusType, StatusType } from "./statusTypes";

/**
 * Compliance priority (highest wins when aggregating).
 * Missed > Incomplete > Pending > Skipped > Complete
 */
export const COMPLIANCE_STATUS_PRIORITY: Record<ComplianceStatusType, number> = {
  missed: 5,
  incomplete: 4,
  pending: 3,
  skipped: 2,
  overdue: 4,
  due: 1,
  not_due: 0,
  complete: 0,
};

/**
 * Result priority (highest wins when aggregating).
 * Fail > Failed & Resolved > Pass
 */
export const RESULT_STATUS_PRIORITY: Record<ResultStatusType, number> = {
  fail: 3,
  failed_resolved: 2,
  pass: 1,
};

export function getCompliancePriority(status: ComplianceStatusType): number {
  return COMPLIANCE_STATUS_PRIORITY[status] ?? 0;
}

export function getResultPriority(status: ResultStatusType): number {
  return RESULT_STATUS_PRIORITY[status] ?? 0;
}

/** Positive when `a` outranks `b` (higher priority wins) - e.g. compareCompliancePriority("missed", "pending") > 0. */
export function compareCompliancePriority(a: ComplianceStatusType, b: ComplianceStatusType): number {
  return getCompliancePriority(a) - getCompliancePriority(b);
}

/** Positive when `a` outranks `b` (higher priority wins) - e.g. compareResultPriority("fail", "pass") > 0. */
export function compareResultPriority(a: ResultStatusType, b: ResultStatusType): number {
  return getResultPriority(a) - getResultPriority(b);
}

export function isComplianceStatus(status: StatusType): status is ComplianceStatusType {
  return status in COMPLIANCE_STATUS_PRIORITY;
}

export function isResultStatus(status: StatusType): status is ResultStatusType {
  return status in RESULT_STATUS_PRIORITY;
}
